import { useNavigate } from "react-router-dom";
import { useAuth } from "@/features/Auth/state/AuthContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card";
import { AvatarUpload } from "./AvatarUpload";
import { ProfileInfo } from "./ProfileInfo";
import { useTranslation } from "react-i18next";

export default function ProfileView() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!user) {
    navigate("/login");
    return null;
  }

  return (
    <div className="container max-w-2xl animate-fade-in">
      <Card className="w-full">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">{t("profile.title")}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <AvatarUpload />
          <ProfileInfo />
        </CardContent>
      </Card>
    </div>
  );
};
